export default function articleContents() {
    const content = document.querySelector('[data-article-content]');
    const panel = document.querySelector('[data-contents]');
    if (!content || !panel) return;
    const headings = [...content.querySelectorAll('h2, h3')]
        .filter(heading => heading.textContent.trim() && !heading.closest('.kg-card, .gh-post-upgrade-cta'));
    if (!headings.length) return;

    const ids = new Set([...document.querySelectorAll('[id]')].map(element => element.id));
    const nav = panel.querySelector('nav');
    for (const heading of headings) {
        if (!heading.id) {
            const base = heading.textContent.trim().toLowerCase().normalize('NFKC')
                .replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'section';
            let id = base;
            let suffix = 2;
            while (ids.has(id)) id = `${base}-${suffix++}`;
            heading.id = id;
            ids.add(id);
        }
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.className = 'contents-subheading';
        nav.append(link);
    }
    panel.hidden = false;
}
